/**
 * @author Ariel
 * @description 经销商新增编辑页面
 * @Date 2020/1/10
 * @Update 地址不使用及联组件
 */
import React from "react";
import { connect } from 'dva';
import { framework_tool, component_tool, utils_tool } from '@/tool'
import moment from 'moment'
import { WizTableForm } from "../../../common";

let { WizContainer, modelUtils } = framework_tool;
let { WizCard, WizForm, WizSpin } = component_tool;
let { Session } = utils_tool
const organizationAreaConfig = WizTableForm.Config.dealer(this, { apiParams: { state: 1, } })

class DealerDetail extends WizContainer {
  componentName = 'dealerDetail';

  constructor(props) {
    super(props);
    const { history } = props;
    let initialValue = {};
    let dealerState = 2;
    let cardTitle = '新增'
    if (history.location && history.location.pathname === '/org/dealer/dealerDetailUpd') {
      if (history.location && history.location.record) {
        initialValue = history.location.record;
        dealerState = initialValue.state;
        Session.set('dealerDetailUpd', initialValue)
        Session.set('dealerState', dealerState)
      } else {
        initialValue = Session.get('dealerDetailUpd') || {};
        dealerState = Session.get('dealerState') || 2;
      }
      cardTitle = '编辑'
    }
    this.state = {
      cardTitle,
      isBrandR: (initialValue?.brand && initialValue.brand != "M") ? true : false,
      isBrandM: (initialValue?.brand && initialValue.brand != "R") ? true : false,
      isDealer: initialValue?.type == 1 ? true : false,
      name: null,
      dealerId: initialValue.id,
    }
    this.dealerState = dealerState;
    this.dealerRef;
    this.initialValue = initialValue;
  }

  /**
   * ⭐ 只有路由配置时cached: true 才会有此生命周期, 且刷新逻辑需自行实现
   * 编辑时可能会触发重置,如果关键字id不同,则判定是新进入,将重新渲染表单
   */
  _componentDidRecover() {
    const { history } = this.props;
    let initialValue = {};
    if (history.location && history.location.pathname === '/org/dealer/dealerDetailUpd') {
      if (history.location.record) {
        initialValue = history.location.record;
        Session.set('dealerDetailUpd', initialValue)
      } else {
        initialValue = Session.get('dealerDetailUpd') || {};
      }
    }
    if (initialValue.id != this.initialValue.id) {
      this.initialValue = initialValue
      this.setState({dealerId:initialValue.id})
    }
  }
  _componentDidMonut() {
    const { history } = this.props;
  }

  propsAndStateOnChange = {
    addDealer: this._addDealerOver.bind(this)
  }

  /**
   * 经销商变动成功返回原页面，失败弹出提示
   * @param nextProps
   * @param nextState
   * @private
   */
  _addDealerOver(nextProps, nextState) {
    if (nextProps.addDealer.code == 1) {
      wizNotice.success('保存成功');
      this.jumpPage('replaceAndDelCrumb', '/org/dealer');
    } else {
      wizNotice.error('提交失败：' + nextProps.addDealer.msg);
    }
    return true;
  }

  /**
   * 过滤字段值为undefined&null的字段
   * @param fieldsValue
   */
  fitterFieldsValue(fieldsValue) {
    let fitterValues = {};
    Object.keys(fieldsValue).forEach(key => {
      const value = fieldsValue[key];
      if (value != null && value != undefined) {
        if (key === 'openTime') {
          fitterValues[key] = moment(value).format("YYYY-MM-DD HH:mm:ss")
        } else {
          fitterValues[key] = value;
        }
      }
    });
    return fitterValues;
  }

  /**
   * 保存/更新 经销商信息
   * @param values
   * @private
   */
  _saveDealer(values) {
    const { history } = this.props;
    let apiPath = 'dealer/add';
    if (history.location && history.location.pathname === '/org/dealer/dealerDetailUpd') {
      apiPath = "dealer/update"
    }
    let fitterValues = this.fitterFieldsValue(values)
    this.doAction({
      path: apiPath,
      payload: {
        key: "addDealer",
        apiParams: {
          ...fitterValues
        }
      }
    });
  }

  _render() {
    const { dealerLoading } = this.props;
    const this1 = this;
    let initialValue = this.initialValue;
    const { areaId, dealerParentInfo } = initialValue
    let initOrgIdR = null
    let initOrgIdM = null
    let initOrgId = null
    let initDealerParentInfoR = [];
    let initDealerParentInfoM = [];
    let initDealerParentInfo = [];
    if (dealerParentInfo && dealerParentInfo[0]) {
      initDealerParentInfoR = [{ id: dealerParentInfo[0]["idR"], name: dealerParentInfo[0]["nameR"] }]
      initOrgIdR = dealerParentInfo[0]["idR"]
      initDealerParentInfoM = [{ id: dealerParentInfo[0]["idM"], name: dealerParentInfo[0]["nameM"] }]
      initOrgIdM = dealerParentInfo[0]["idM"]
      initDealerParentInfo = [{ id: dealerParentInfo[0]["id"], name: dealerParentInfo[0]["name"] }]
      initOrgId = dealerParentInfo[0]["id"]
    }
    let columns = []
    columns = columns.concat([
      {
        name: 'id',
        formItem: {
          type: 'hidden',
          initialValue: this.initialValue.id
        }
      },
      {
        title: '经销商名称',
        name: 'name',
        formItem: {
          maxLength: 50,
          placeholder: '经销商名称最多输入50个字',
          rules: [
            {
              required: true,
              message: '请输入经销商名称',
            },
            {
              pattern: /^[^\s]*$/,
              message: '经销商名称录入信息不能包含空格'
            }
          ],
          initialValue: this.initialValue.name
        }
      },
      {
        title: '站点类型',
        name: 'type',
        dict: [
          { code: 1, codeName: '经销商' },
          { code: 2, codeName: '服务商' },
        ],
        formItem: {
          disabled:this.initialValue?.id,
        onChange: (form, type) => {
          if (type == 1) {
            this1.setState({ isDealer: true })
          } else {
            this1.setState({ isDealer: false })
          }
        },
          rules: [{
            required: true,
            message: '请选择站点类型',
          }],
          initialValue: this.initialValue.type ,
          type: 'select'
        }
      }]);
    if (this.state.isDealer) {
      columns = columns.concat([{
        title: '品牌',
        name: 'brand',
        dict: [
          { code: "R", codeName: '荣威' },
          { code: "M", codeName: '名爵' },
          { code: "A", codeName: '双品牌' },
        ],
        formItem: {
          rules: [{
            required: true,
            message: '请选择品牌',
          }],
          onChange: (form, brand) => {

            if (brand === "R") {
              this1.setState({ isBrandR: true, isBrandM: false })
            } else if (brand === "M") {
              this1.setState({ isBrandR: false, isBrandM: true })
            } else if (brand === "A") {
              this1.setState({ isBrandR: true, isBrandM: true })
            } else {
              this1.setState({ isBrandR: false, isBrandM: false })
            }
          },
          initialValue: this.initialValue.brand,
          type: 'select'
        }
      },

      {
        title: '荣威上级组织',
        name: 'orgIdR',
        formItem: {
          type: 'diy',
          diy: WizTableForm,
          config: this.state.isBrandR,
          ...organizationAreaConfig,
          initialValue: initOrgIdR,
          initRows: initDealerParentInfoR,
          selectType: 'radio',
          rules: [{
            required: this.state.isBrandR,
            message: '请选择荣威上级组织',
          }],
        }
      },
      {
        title: '名爵上级组织',
        name: 'orgIdM',
        formItem: {
          type: 'diy',
          diy: WizTableForm,
          config: this.state.isBrandM,
          ...organizationAreaConfig,
          initialValue: initOrgIdM,
          initRows: initDealerParentInfoM,
          selectType: 'radio',
          rules: [{
            required: this.state.isBrandM,
            message: '请选择名爵上级组织',
          }],
        }
      }]);
    }else{

      columns = columns.concat([{
        title: '上级组织',
        name: 'orgId',
        formItem: {
          ...organizationAreaConfig,
          diy: WizTableForm,
          initialValue: initOrgId,
          initRows: initDealerParentInfo,
          selectType: 'radio',
          rules: [{
            required: true,
            message: '请选择上级组织',
          }]
        }
      }]);
    }
    columns = columns.concat([,
      {
        title: '经销商简称',
        name: 'shortName',
        formItem: {
          maxLength: 50,
          placeholder: '经销商简称最多输入50个字',
          rules: [
            {
              required: true,
              message: '请输入经销商简称',
            },
            {
              pattern: /^[^\s]*$/,
              message: '经销商简称录入信息不能包含空格'
            }
          ],
          initialValue: this.initialValue.shortName
        }
      },
      {
        title: '销售代码',
        name: 'preSalesNumber',
        formItem: {
          maxLength: 50,
          placeholder: '销售代码最多输入50个字',
          rules: [
          {
            required: this.state.isDealer,
            message: '请选择名爵上级组织',
          },
            {
              pattern: /^[^\u4e00-\u9fa5, ]{0,}$/,
              message: '销售代码禁止输入中文和空格'
            }
          ],
          initialValue: this.initialValue.preSalesNumber
        }
      },
      {
        title: '售后代码',
        name: 'afterSalesNumber',
        formItem: {
          maxLength: 50,
          placeholder: '售后代码最多输入50个字',
          rules: [
            {
              required: !this.state.isDealer,
              message: '请选择名爵上级组织',
            },
            {
              pattern: /^[^\u4e00-\u9fa5, ]{0,}$/,
              message: '售后代码禁止输入中文和空格'
            }
          ],
          initialValue: this.initialValue.afterSalesNumber
        }
      },
      {
        title: '开店状态',
        name: 'state',
        dataIndex: 'state',
        dict: [
          { code: 3, codeName: '待开业' },
          { code: 1, codeName: '开业' },
          { code: 2, codeName: '停业' }
        ],
        formItem: {
          rules: [{
            required: true,
            message: '请选择开店状态',
          }],
          initialValue: this.dealerState,
          type: 'select'
        }
      },
      {
        title: '开店时间',
        name: 'openTime',
        formItem: {
          type: 'datetime',
          initialValue: this.initialValue.openTime ? this.initialValue.openTime : null
        }
      },
      {
        title: '省份',
        name: 'province',
        formItem: {
          maxLength: 30,
          placeholder: '省份最多输入30个字',
          rules: [
            {
              required: true,
              message: '请输入省份',
            },
            {
              pattern: /^[\u4e00-\u9fa5]+$/,
              message: '省份只允许输入中文'
            }
          ],
          initialValue: this.initialValue.province
        }
      },
      {
        title: '城市',
        name: 'city',
        formItem: {
          maxLength: 30,
          placeholder: '城市最多输入30个字',
          rules: [
            {
              required: true,
              message: '请输入城市',
            },
            {
              pattern: /^[\u4e00-\u9fa5]+$/,
              message: '城市只允许输入中文'
            }
          ],
          initialValue: this.initialValue.city
        }
      },
      {
        title: '地区',
        name: 'region',
        formItem: {
          maxLength: 30,
          placeholder: '地区最多输入30个字',
          initialValue: this.initialValue.region
        }
      },
      {
        title: '详细地址',
        name: 'address',
        formItem: {
          maxLength: 100,
          placeholder: '详细地址最多输入100个字',
          rules: [{
            required: true,
            message: '请输入详细地址',
          }],
          initialValue: this.initialValue.address
        }
      },
      {
        title: '所属集团',
        name: 'bloc',
        formItem: {
          maxLength: 20,
          placeholder: '所属集团最多输入20个字',
          initialValue: this.initialValue.bloc
        }
      },
      {
        title: '备注',
        name: 'remark',
        formItem: {
          maxLength: 100,
          placeholder: '备注最多输入100个字',
          type: 'textarea',
          initialValue: this.initialValue.remark
        }
      }
    ]);

    let onSubmit = this._saveDealer.bind(this);

    let formProps = {
      ref: 'form',
      key: this.state.dealerId || '', // ⭐如缓存路由需要刷新,必须加标识key
      columns,
      onSubmit,
      record: null,
      preview: null,
      footer: undefined,
      formItemLayout: {
        labelCol: { span: 4 },
        wrapperCol: { span: 17 }
      },
      wrappedComponentRef: (form) => this.dealerRef = form
    }

    return (
      <WizCard>
        <WizSpin tip={'加载中'} spinning={dealerLoading}>
          <WizForm className={'form-inline'} {...formProps} />
        </WizSpin>
      </WizCard>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const { dealer } = state;
  const addDealer = modelUtils.getModelEntity(dealer, "addDealer");
  const load = modelUtils.getLoadingState(state, ['dealer']);
  return {
    addDealer: addDealer,
    ...load
  }
};

export default connect(mapStateToProps)(DealerDetail);
